<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 200 200" enable-background="new 0 0 200 200" xml:space="preserve">
    <g>
    <path fill="none" d="M100.086,44.995c-30.447,0-55.218,24.771-55.218,55.217c0,11.707,3.615,22.89,10.454,32.339
      c1.279,1.766,1.515,4.104,0.612,6.102l-6.842,14.967l23.803-3.962c0.315-0.056,0.66-0.085,1.003-0.085
      c0.888,0,1.788,0.202,2.604,0.584c7.411,3.5,15.344,5.272,23.584,5.272c30.446,0,55.217-24.771,55.217-55.217
      S130.532,44.995,100.086,44.995z"/>
    <path class="color" fill="#F45B5B" d="M100.086,32.78c-37.182,0-67.432,30.25-67.432,67.432c0,13.038,3.707,25.632,10.733,36.513l-10.184,22.273
      c-0.866,1.899-0.709,4.079,0.417,5.832c1.134,1.763,3.049,2.815,5.123,2.815c0.338,0,0.681-0.028,1.021-0.085l33.304-5.55
      c8.543,3.738,17.628,5.633,27.017,5.633c37.182,0,67.432-30.25,67.432-67.432S137.268,32.78,100.086,32.78z M100.086,155.429
      c-8.24,0-16.173-1.772-23.584-5.272c-0.815-0.382-1.716-0.584-2.604-0.584c-0.343,0-0.688,0.029-1.003,0.085l-23.803,3.962
      l6.842-14.967c0.902-1.997,0.667-4.336-0.612-6.102c-6.839-9.449-10.454-20.632-10.454-32.339
      c0-30.446,24.771-55.217,55.218-55.217c30.446,0,55.217,24.771,55.217,55.217S130.532,155.429,100.086,155.429z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CommentBubbleIcon'
}
</script>
